@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.background-circle {
  stroke: @donut-chart--background-circle--icon-color;
}
